// src/components/strumenti/ConversioneLumenLux.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function ConversioneLumenLux() {
  const [modo, setModo] = useState("lumen_lux");
  const [valore, setValore] = useState("");
  const [superficie, setSuperficie] = useState("");

  const v = leggiNumero(valore)||0;
  const mq = leggiNumero(superficie)||0;
  const risultato = mq>0 ? (modo==="lumen_lux" ? v/mq : v*mq) : null;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>{setModo("lumen_lux");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="lumen_lux"?"#d97706":"#e5e7eb"}`, background: modo==="lumen_lux"?"#fffbeb":"#fff", color: modo==="lumen_lux"?"#d97706":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Lumen → Lux</button>
        <button onClick={()=>{setModo("lux_lumen");setValore("");}} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${modo==="lux_lumen"?"#d97706":"#e5e7eb"}`, background: modo==="lux_lumen"?"#fffbeb":"#fff", color: modo==="lux_lumen"?"#d97706":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Lux → Lumen</button>
      </div>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>{modo==="lumen_lux" ? "Flusso luminoso totale (lm)" : "Illuminamento desiderato (lux)"}</label>
          <input value={valore} onChange={e=>setValore(e.target.value)} style={inp} placeholder={modo==="lumen_lux"?"Es. 4000":"Es. 300"}/>
        </div>
        <div>
          <label style={lbl}>Superficie (m²)</label>
          <input value={superficie} onChange={e=>setSuperficie(e.target.value)} style={inp} placeholder="Es. 20"/>
        </div>
      </div>

      <div style={{ background:"#fffbeb", border:"1px solid #fde68a", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{modo==="lumen_lux" ? "Illuminamento medio" : "Flusso luminoso necessario"}</div>
        <div style={{ fontSize:22, fontWeight:800, color:"#d97706" }}>
          {risultato===null ? "—" : risultato.toLocaleString("it-IT",{maximumFractionDigits:0})}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modo==="lumen_lux" ? "lux" : "lm"}</span>
        </div>
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Calcolo medio semplificato — non tiene conto di altezza, riflettanza delle superfici o distribuzione degli apparecchi.
      </div>

      <button onClick={()=>{setValore("");setSuperficie("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
